module.exports = __webpack_public_path__ + "img/ios-icon.01e46072.svg";